import React from "react"
import { withRouter } from "react-router-dom"

import ReactSVG from "react-svg"
import { Button, Dropdown, Image } from "semantic-ui-react"
import { formatParagraph } from "../../helpers/stringHelpers"
import { Chip } from "../../components/tires/Chip"
import { numberFormatToCurrency } from "../../components/tires/currency"
import CartTick from "../../assets/images/cart_tick.svg"
import SheildIcon from "../../assets/images/warranty-logo.svg"
import DefaultLogo from "../../assets/images/NoLogoAvailable.png"
import CartIcon from "../../assets/images/icon-cart.svg"
import defaultTire from "../../assets/images/DefaultTire.png"
import { formatPriceNumber } from "../../helpers/numberHelpers"
import { routerPaths } from "../../constants/paths"
import { NO, YES } from "../../constants/orders"
import { DEFAULT_TIRE_QUENTY } from "../../constants/tires"
import CarAdviseLogo from "../../assets/images/CA-short.svg"
import store from "../../actions/configureStore"
import {
  SAVE_SELECTED_TIRE,
  SAVE_SELECTED_TIRE_OBJECT
} from "../../actions/tire_action/tiresActions"

const TireDetailsSize = ({
  tire,
  tireQty,
  changeHandler,
  selectedTire,
  openDeleteModal,
  handleAddToCartBtn,
  t,
  objectCollection,
  history
}) => {
  const onImageError = (e) => {
    e.target.src = defaultTire
  }
  const dataprovider = objectCollection.map((object) => {
    return { key: object.id, value: object, text: object.label }
  })
  const handleSeeDetails = () =>
    store.dispatch({
      type: SAVE_SELECTED_TIRE_OBJECT,
      payload: tire
    })
  return (
    <div
      className="tire-list-margin"
      onClick={() => {
        handleSeeDetails()
        history.push(routerPaths.tireDetails)
      }}
    >
      {tire.is_top && (
        <div className="caradvise-recommended">
          <div className="label-container">
            <ReactSVG className="CA_white" src={CarAdviseLogo} />
            <p className="recommended-label">{t("tireFilters:caradviseRecommends")}</p>
          </div>
        </div>
      )}

      <div className="tire-card" key={tire.id}>
        <div className="tire-image-container">
          <Image
            src={tire && tire.image ? tire.image : defaultTire}
            onError={onImageError}
            className="tire-size-image"
          />
        </div>
        <div className="tire-size-details-container">
          <div className="tire-size-details-section">
            <div className="tire-size-company-details">
              <Image
                src={tire.brand_logo || tire.image || DefaultLogo}
                className="tire-image-brand-logo"
              />
              <div className="tire-brand-miles-details">
                {tire.mileage_rating ? (
                  <Chip
                    icon={SheildIcon}
                    label={`${formatPriceNumber(tire.mileage_rating)} ${t(
                      "confirmOrderDialog:miles"
                    )} ${t("confirmOrderDialog:warranty")}`}
                    backgroundColor={"#F8F8F8"}
                  />
                ) : null}
                {tire.season ? (
                  <Chip
                    label={formatParagraph(`${t("seasonLabel")}: *${tire.season}*`, 600)}
                    backgroundColor={"#FEF6F4"}
                  />
                ) : null}
              </div>
            </div>
            <div className="tire-size-details">
              <div className="tire-name">{tire && tire.brand + " " + tire.model}</div>
              <div className="tire-size-details-section">
                <span className="tire-size-detail"> {tire && tire.size}</span>
                <span className="details_link" onClick={handleSeeDetails}>
                  {t("seeDetailsLabel")}
                </span>
              </div>
              <div className="tire-size-config-section">
                <div className="tire-size-config">
                  {t("runFlatLabel")} <strong>{tire.run_flat ? YES : NO}</strong>
                </div>
                <div className="tire-size-config">
                  {t("loadRangeLabel")} <strong>{tire.load_range ? tire.load_range : "-"}</strong>
                </div>
                <div className="tire-size-config">
                  {t("speedRatingLabel")}{" "}
                  <strong>{tire.speed_rating ? tire.speed_rating : "-"}</strong>
                </div>
              </div>
            </div>
          </div>
          <div className="tire-size-cart-section">
            <div className="tire-cart-summary">
              <div className="tire-price-section">
                <div className="tire-price">{tire && numberFormatToCurrency(tire.price)}/tire</div>
                <div className="tire-price-summary">
                  {tireQty && tireQty.filter((item) => item.tireId === tire.id).length > 0
                    ? `${numberFormatToCurrency(
                        tireQty.filter((item) => item.tireId === tire.id)[0].quantity * tire.price
                      )} ${t("setForLabel")} ${
                        tireQty.filter((item) => item.tireId === tire.id)[0].quantity
                      }`
                    : `${numberFormatToCurrency(DEFAULT_TIRE_QUENTY * tire.price)} ${t(
                        "setForLabel"
                      )} ${DEFAULT_TIRE_QUENTY}`}
                </div>
              </div>
              <div>
                <Dropdown
                  options={dataprovider}
                  onClick={(e) => e.stopPropagation()}
                  onChange={(event, data) => changeHandler(event, data, tire)}
                  className="tire-qty-dropdown"
                  placeholder={
                    tireQty && tireQty.filter((item) => item.tireId === tire.id).length > 0
                      ? tireQty.filter((item) => item.tireId === tire.id)[0].quantity
                      : DEFAULT_TIRE_QUENTY
                  }
                />
              </div>
            </div>
            <div className="add-button">
              <Button
                className={
                  Object.keys(selectedTire).length === 0
                    ? "shop-btn"
                    : selectedTire.id === tire.id
                    ? "shop-btn-selected"
                    : "shop-btn-disabled"
                }
                onClick={(e) => {
                  e.stopPropagation()
                  selectedTire.id === tire.id ? openDeleteModal(tire) : handleAddToCartBtn(tire)
                }}
              >
                <ReactSVG
                  src={selectedTire.id === tire.id ? CartTick : CartIcon}
                  className="shop-button-icon"
                />
                {selectedTire.id === tire.id ? t("addedToCartLabel") : t("Add_to_cart")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default withRouter(TireDetailsSize)
